import { Breadcrumb, BreadcrumbItem } from '@acme/foundation';
import { Button } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';
import { ExchangeRateForm } from '../ui';

export const ExchanegeRatesCreatePage = () => {
  const navigate = useNavigate();

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: 'Главная',
      onClick: () => navigate('/dashboard'),
    },
    {
      label: 'Создать новый курс валюты',
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={breadcrumbItems} />

      <div className="flex gap-3">
        <h2 className="flex-1 text-2xl font-bold">Создать новый курс валюты</h2>

        <Button color="primary" onClick={() => navigate(-1)}>
          Назад
        </Button>
      </div>

      <ExchangeRateForm />
    </div>
  );
};
